import { get, has } from 'lodash';
import appConfig from 'Config';
import { isSeller } from 'Utils/seller/sellerUtils';
type KeyInfo = {
  b2cKey: string;
  b2cLegacyMobileKey: string;
  b2cMobileKey: string;
  b2cDesktopKey: string;
  sellerKey: string;
};

function _getKeyFromCms(
  currentPath: string,
  locale: string,
  featureFlippingKeysFromCms: CMSFeatureFlips,
) {
  if (!featureFlippingKeysFromCms || typeof featureFlippingKeysFromCms !== 'object') {
    return null;
  }

  const overrideKey = `override.${locale}.${currentPath}`;

  if (locale && has(featureFlippingKeysFromCms, overrideKey)) {
    return get(featureFlippingKeysFromCms, overrideKey, null);
  }

  return get(featureFlippingKeysFromCms, currentPath, null);
}

function _getKey(locale: string, featureFlippingKeysFromCms: CMSFeatureFlips) {
  return (...paths: Array<string>): any => {
    return !!paths.reduce((resolved, currentPath) => {
      if (typeof resolved !== 'boolean') {
        const valueFromCms = _getKeyFromCms(currentPath, locale, featureFlippingKeysFromCms);

        return valueFromCms === null || typeof valueFromCms !== 'boolean'
          ? appConfig.get(currentPath, locale)
          : valueFromCms;
      }

      return resolved;
    }, null);
  };
}

function getKeyInfo(key): KeyInfo {
  return {
    b2cKey: `featureFlipping.${key}`,
    b2cLegacyMobileKey: `featureFlipping.mobile.${key}`,
    b2cMobileKey: `featureFlipping.${key}.mobile`,
    b2cDesktopKey: `featureFlipping.${key}.desktop`,
    sellerKey: `featureFlipping.seller.${key}`,
  };
}

export function isFeatureFlipped(
  appContext: AppContext,
  isMobile: boolean = false,
): (arg0: string) => any {
  return (key) => {
    const featureFlippingKeysFromCms = get(appContext, 'featureFlippingKeysFromCms');
    const locale = get(appContext, 'locale');

    const getKey = _getKey(locale, featureFlippingKeysFromCms);

    const { b2cKey, b2cDesktopKey, b2cLegacyMobileKey, b2cMobileKey, sellerKey } = getKeyInfo(key);

    if (isSeller(appContext)) {
      return getKey(sellerKey, b2cKey);
    }

    return isMobile
      ? getKey(b2cMobileKey, b2cLegacyMobileKey, b2cKey)
      : getKey(b2cDesktopKey, b2cKey);
  };
}
